import React, { useState, useMemo, useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import { CommodityField } from '@commonComponents/formComponents/CommodityCodeField'
import { useTranslation } from '@hooks/useTranslation'
import { useSelector } from 'react-redux'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import { selectMeasurementUnitList } from '@EUForms/selectors'
import { MultiSelectDropDown } from '@EUForms/MultiSelectDropDown'
import PopUpIcon from '@commonComponents/formComponents/PopUpIcon'

const MerchandiseSummaryEditable = (props) => {
  const {
    merchandiseId,
    invoiceId,
    dataSource: {
      taricCode,
      commodityCode,
      convertedValue,
      grossMass,
      netMass,
      procedure,
      preference,
      prefOrigin,
      originCountry,
      unitOfMeasurement,
      packageCount,
      taricAdditionalCodesList,
      itemPrice,
      packagesList,
      nationalAdditionalCodesList
    },
    onSelect,
    onBlur,
    onChange,
    // originCountry: originCountryTransport,
    // destinationCountry: destinationCountryTransport,
    countryList,
    proceduresList,
    validateLineItem,
    submit
  } = props
  const [showModal, setShowModal] = useState(false)
  const { currency, exchangeRate } = useSelector((state) => state.invoiceReducer.invoice.invoiceMap[invoiceId]?.invoiceHeader) || {}
  const uomList = useSelector(selectMeasurementUnitList)
  const translate = useTranslation();
  const { isImportShipment, serviceType, version, isDisabled } = useCurrentShipmentType()

  const totalPackages = useMemo(() => {
    return packagesList?.reduce((prev, curr) => {
      return prev + (parseInt(curr?.quantity) || 0)
    }, 0)
  }, [packagesList])


  const onChangeHandler = useCallback(
    ({ target: { value, name } }) => onChange(value, name),
    [merchandiseId, onChange]
  )
  const onDropDownChange = useCallback(
    (e, { value, name }) => onSelect(value, name),
    [merchandiseId, onSelect]
  )
  const onBlurHandler = useCallback(
    ({ target: { value, name } }) => onBlur(value, name),
    [merchandiseId, onBlur]
  )

  return (
    <Grid className='responsiveGridCss'>
      <Grid.Row>
        <CommodityField
          id={`commodityCode-${invoiceId}-${merchandiseId}`}
          htsEnabled={true}
          htsBoxNumber='6/14'
          taricBoxNumber='6/15'
          label='COM_NOMECLATURE'
          htsCode={commodityCode}
          version={version}
          commodityCode={commodityCode}
          taricCode={taricCode}
          taricWidth='2'
          isImportShipment={isImportShipment}
          serviceType={serviceType}
          taricLabel='TARIC_CODE'
          translate={translate}
          showModal={showModal}
          setShowModal={setShowModal}
          submit={submit}
          onHtsPopupChange={({ htsCode, taricCode }) => {
            onChangeHandler({ target: { name: 'commodityCode', value: htsCode } })
            onBlurHandler({ target: { value: htsCode, name: 'commodityCode' } })
            if (taricCode) {
              onChangeHandler({ target: { name: 'taricCode', value: taricCode } })
              onBlurHandler({ target: { value: taricCode, name: 'taricCode' } })
            }
          }}
          onBlur={({ taricCode, htsCode }) => {
            !taricCode && validateLineItem && validateLineItem('commodityCode', htsCode)
            !htsCode && validateLineItem && validateLineItem('commodityCode', taricCode)
            !taricCode && onBlurHandler({ target: { value: htsCode, name: 'commodityCode' } })
            !htsCode && onBlurHandler({ target: { value: taricCode, name: 'taricCode' } })
          }}
          onHtsChange={(value) => onChangeHandler({ target: { name: 'commodityCode', value } })}
          onTaricChange={(value) => onChangeHandler({ target: { name: 'taricCode', value } })}
        />
        {/* <Grid.Column width='1'>
          <InputField
            id={`tarricAddCode${merchandiseId}`}
            type='text'
            label="TARIC_ADD_CODE"
            value={
              taricAdditionalCodesList?.length > 0 &&
              taricAdditionalCodesList?.at(-1)?.code || ''
            }
            clearInput={false}
            isDisabled={true}
          />
        </Grid.Column> */}
        <Grid.Column width='2' className='multiSelect_DropDown'>
          <MultiSelectDropDown
            label={'TARIC_EU_ADD_CODE'}
            merchandiseId={merchandiseId}
            invoiceId={invoiceId}
            translate={translate}
            valueKey='code'
            fieldType={'input'}
            labelIcon={
              <PopUpIcon
                icon='info circle'
                position='top right'
                popupText={translate('FOUR_DIGITS_MESSAGE')}
              />
            }
            boxNumber={'6/15'}
            tableName='taricAdditionalCodesList'
            dataList={taricAdditionalCodesList}
          />
        </Grid.Column>
        <Grid.Column width='2' className='multiSelect_DropDown'>
          <MultiSelectDropDown
            label='NATIONAL_ADD_CODE'
            merchandiseId={merchandiseId}
            invoiceId={invoiceId}
            translate={translate}
            boxNumber='6/17'
            valueKey='code'
            labelIcon={
              <PopUpIcon icon='info circle' popupText={translate('FOUR_DIGITS_MESSAGE')} />
            }
            fieldType={'input'}
            tableName='nationalAdditionalCodesList'
            dataList={nationalAdditionalCodesList}
          />
        </Grid.Column>

        <Grid.Column width='1'>
          <InputField
            id={`EurValue${merchandiseId}`}
            type='text'
            label="EUR_VALUE"
            value={convertedValue}
            clearInput={false}
            isDisabled={true}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <DropDown
            isLabel={true}
            id={`procedure-${invoiceId}-${merchandiseId}`}
            type='text'
            label="PROCEDURE"
            boxNumber='1/10'
            value={procedure}
            text={procedure}
            data={proceduresList}
            direction='left'
            clearable
            name='procedure'
            onChange={onDropDownChange}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        {/* <Grid.Column width='1'>
          <InputField
            id={`preference-${invoiceId}-${merchandiseId}`}
            type='text'
            label='PREFERENCE'
            boxNumber='5/16'
            value={preference}
            name='preference'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column> */}
        <Grid.Column width='1'>
          <DropDown
            isLabel={true}
            id={`origin-${invoiceId}-${merchandiseId}`}
            type='text'
            label="ORIGIN"
            boxNumber='5/15'
            value={originCountry}
            text={originCountry}
            data={countryList}
            clearable
            name='originCountry'
            onChange={onDropDownChange}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            isLabel={false}
            id={`grossMass-${invoiceId}-${merchandiseId}`}
            type='text'
            label="GROSS_MASS"
            isDisabled={isDisabled || null}
            value={grossMass}
            name='grossMass'
            boxNumber='6/4'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            isLabel={false}
            id={`netMass-${invoiceId}-${merchandiseId}`}
            type='text'
            label='NET_MASS_DMS'
            isDisabled={isDisabled || null}
            boxNumber='6/4'
            value={netMass}
            name='netMass'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`qty${merchandiseId}`}
            type='text'
            label="TOT_PKG_QTY"
            boxNumber={'6/10'}
            value={totalPackages}
            clearInput={false}
            isDisabled={true}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <DropDown
            id={`uom-${invoiceId}-${merchandiseId}`}
            type='text'
            label="UOM"
            value={unitOfMeasurement}
            text={unitOfMeasurement}
            data={uomList}
            clearable
            name='unitOfMeasurement'
            onChange={onDropDownChange}
            isDisabled={isDisabled || null}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
export default MerchandiseSummaryEditable
